import styles from './styles.scss'

export default `
<div
  class="${styles.item} ${styles.itemLike}"
  data-like
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      class="${styles.activePath}"
      fill-rule="evenodd"
      d="M0 0v20V0zm20 0v20V0zm-9.46 1.15a1 1 0 0 1 1.49-.47l1.53 1.02a1 1 0 0 1 .44.83V6l-1 2h4a1 1 0 0 1 1 1v5.67a1 1 0 0 1-.2.6l-2.5 3.33a1 1 0 0 1-.8.4H7V7.15L9 5l1.54-3.85zM5.5 8v11H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.5z"
    />
    <path
      class="${styles.normalPath}"
      fill-rule="evenodd"
      d="M20 0v20V0zM0 0v20V0zm16.5 14.5-2.25 3H7V9.34l3.29-3.52 1.42-3.55.79.53v2.85L10.57 9.5h5.93v5zm-13 3h2v-8h-2v8zM13 8l1-2V2.54a1 1 0 0 0-.45-.84L12.03.68a1 1 0 0 0-1.48.47L9 5 6.2 8H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h11.5a1 1 0 0 0 .8-.4l2.5-3.33a1 1 0 0 0 .2-.6V9a1 1 0 0 0-1-1h-4z"
    />
  </svg>
</div>
<div
  class="${styles.item} ${styles.itemDislike}"
  data-dislike
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
    class="${styles.activePath}"
      fill-rule="evenodd"
      d="M20 20V0v20zM0 20V0v20zm9.46-1.15a1 1 0 0 1-1.49.47L6.44 18.3a1 1 0 0 1-.44-.84V14l1-2H3a1 1 0 0 1-1-1V5.33a1 1 0 0 1 .2-.6L4.7 1.4a1 1 0 0 1 .8-.4H13v11.85L11 15l-1.54 3.85zM14.5 12V1H17a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2.5z"
    />
    <path
      class="${styles.normalPath}"
      fill-rule="evenodd"
      d="M0 20V0v20zm20 0V0v20zM3.5 5.5l2.25-3H13v8.16l-3.29 3.52-1.42 3.55-.79-.53v-2.85l1.93-3.85H3.5v-5zm11 5h2v-8h-2v8zM7 12l-1 2v3.46a1 1 0 0 0 .45.84l1.53 1.02a1 1 0 0 0 1.48-.47L11 15l2.8-3H17a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H5.5a1 1 0 0 0-.8.4L2.2 4.73a1 1 0 0 0-.2.6V11a1 1 0 0 0 1 1h4z"
    />
  </svg>
</div>`
